import React, { useEffect, useState } from 'react'
import { checkPriority, convertMilliSecToDateNew, priorityClass } from '../../utils/EllowUtils';
import Styles from "./styles.module.scss";
import { Icon } from '@iconify/react';
import resourceIcon from "../../assets/images/resource_icon.svg";
import levelIcon from "../../assets/images/level_icon.svg";
import timeIcon from "../../assets/images/time_icon.svg";
import calendarIcon from "../../assets/images/calendar_icon.svg";
import billingIcon from "../../assets/images/billing_icon.svg";
import crownIcon from "../../assets/images/crown_icon.svg";
import workType from "../../assets/images/work-type.svg"
import docIcon from "../../assets/images/document_icon.svg";
import locationIcon from "../../assets/images/loc-icon.svg";
import Table from '../../components/table';
import Button from "../../components/button";
import { Link, useNavigate } from "react-router-dom";
import  FreeField  from '../../components/field/freeField';
import {  postAPI } from '../../api/api'
import { REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common";
import DOMPurify from "dompurify";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  Modifier,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { convertToHTML } from "draft-convert";



function AppliedCandidates(props:any) {
 
  const loginId = localStorage.getItem('loginId')
  const navigate = useNavigate();
  const[lossCountNum, setLossCountNum] = useState<any>('')
  const [appliedResources, setAppliedResources] = useState<any>()
  const [DownloadresumeName, setDownloadResumeName] = useState<string | null>(null)
  const [resumeName, setResumeName] = useState<string | null>(null)
  const [crowdSourcingTable, setCrowdSourcingTable] = useState<boolean>(false)
  const [providerTable, setProviderTable] = useState<boolean>(false)
  const [jobMetadata, setJobMetadata] = useState<{
    resourceCount: number , experienceRange: {min: number , max: number} , contractDuration : string , contractStartDate: any , minimumBudget: any , maximumBudget: any ,
    billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}],
    closedCount: number , jobDescription : string, priority: number, jobResponsibilities: string , supportingDocument: string , locationPreference: any, jobType: string
  }>({
    resourceCount: 0, experienceRange: {min: 0 , max: 12}  , contractDuration: "" , contractStartDate: 0 , minimumBudget: 0 , maximumBudget: 0 ,
    billingType: "",jobRole: {id: 0, name: ""} , coreSkills: [{skillId: 0, skillName: ""}] , otherSkills: [{skillId: 0, skillName: ""}],
    closedCount: 0 , jobDescription : "" , priority: 5, jobResponsibilities: '' , supportingDocument: "" , locationPreference: [], jobType: ''
  })

useEffect(() => {
   
  if (props.appliedResources) {
    const newValue = props && props.appliedResources && props.appliedResources.map((valueItem: any) => {
      valueItem.availabilityValue = {
        availability: valueItem.availability,
        availability_date: valueItem.availabilityDate,
        availability_lastUpdatedDate: valueItem.availabilityLastUpdateDate,
        availability_week: valueItem.availabilityWeeks,
        contractStartDate: valueItem && valueItem.contractMetadata && valueItem.contractMetadata.contractStartDate,
        contractEndDate: valueItem && valueItem.contractMetadata && valueItem.contractMetadata.contractEndDate
      }
      return valueItem
    })  
    setAppliedResources(props.appliedResources)   
    setJobMetadata(props.jobMetadata)    
    if(props.jobMetadata.supportingDocument.length > 0){
      setDownloadResumeName(props.jobMetadata.supportingDocument)
      setResumeName((props.jobMetadata.supportingDocument.slice(36)))
    }    
  }
  if (props && props.jobMetadata && props.jobMetadata.lossCount !== 0) {
     setLossCountNum(props.jobMetadata.lossCount)
  }  
}, [props.appliedResources, props.jobMetadata])

 
const applyPosition = () => {
  navigate('/applyPositions', {state: {jobId: props.jobId, companyName: props.companyName}} )
  }
  
  const lossCount = (event: any) => {
    if (event.target.value && event.target.value !== '') {
    props.lossCount(event.target.value)  
    }
  }

  const countChange = (event: any) => {
    setLossCountNum((event.target.value).replace('-',''))
  }

  const downloadHandle=(name:any)=>{
     
    const fileName=DownloadresumeName;
    let value = {
      "action":"getObject",
      "filename":fileName,
      "bucketName":"ellow-prod-doc-upload",
    };
    postAPI(REACT_APP_CANDIDATE_FRELLANCER +'/resume-signed-url',value) .then((data) => {
    let signedUrl = data.url;
    const fileName=decodeURIComponent((name.slice(36, name.length)))  
    
    fetch(signedUrl).then((response: any) => {
      response.blob().then((blob: any) => {
          const fileURL = window.URL.createObjectURL(blob);
          let alink = document.createElement('a');
          alink.href = fileURL;
          alink.download =fileName;
          alink.click();
      })
  })
  });
  }

  const createMarkup = (html: any) => {
    if (html.includes('{"blocks')) {
      let oldblockconverteddata = convertFromRaw(JSON.parse(html));
      let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);

      html = JSON.stringify(oldblockdataconvertedhtml);
      return {
        __html: DOMPurify.sanitize(html).replace(/"/g,''),
      };
    }
    if (html.includes("<p>") || html.includes("<ol") || html.includes("<ul>")) {
      return {
        __html: DOMPurify.sanitize(JSON.parse(html)).replace(/"/g,''),
      };
    } else {
      html = "<p>" + html + "</p>";
      return {
        __html: DOMPurify.sanitize(html).replace(/"/g,''),
      };
    }
  }

  const crowdSourcing = () => {
    if(crowdSourcingTable === false){
      setCrowdSourcingTable(true)
    }else{
      setCrowdSourcingTable(false)
    }
  }

  const providerTableShow = () => {
    if(providerTable === false){
      setProviderTable(true)
    }else{
      setProviderTable(false)
    }
  }

  return (
    <section className={Styles.dashboardWrapper}>
      { props && props.jobStatus && props.jobStatus === 3 && <div className={Styles.positionbadge}>
        <span>Position Closed</span>
      </div>}
    <div className="content-wrapper-box">
      <div className={Styles.positionhead}>
        <h3 className="headWithLabel">Applied Candidates </h3>
        { props && props.jobStatus && props.jobStatus !== 3 && loginId === props.allocatedToId && <Button onClick={applyPosition} variant="primary" size="small">Apply for this Position</Button>}
      </div>
      <div className={Styles.appliedList}>
        { appliedResources && appliedResources.length > 0 ?     <section>
            <Table data={appliedResources} jobId={props.jobId} type={'appliedCandidates'} total={appliedResources.length} pageChange={props.pageChange} pageSize={props.pageSize} getAppliedCandidates={props.getAppliedCandidates } customerId={props.customerId} jobMetadata={props.jobMetadata} getPositionDetails={props.getPositionDetails} allocatedToId={props.allocatedToId} positionData={props.positionData}/>
        </section>  
        : <div className={Styles.noData}>
              <Icon icon="healthicons:i-groups-perspective-crowd-outline" />
              <p><strong>No resources yet!</strong></p>
              <p>No one has been applied for this position.</p>
          </div> }
      </div>
      {props.positionData && props. positionData.crowdsourcing_enabled === true && 
        <div className={Styles.positionhead2}>
          <h3 className="headWithLabel">Crowd Sourcing Candidates  <div className={Styles.tableCount}>({props.csrappliedResourcesCount})</div></h3>   
          <div className={Styles.actionButton}>
            <Button onClick={() =>{crowdSourcing()}} >{crowdSourcingTable === false ? <Icon icon="akar-icons:plus" /> : <Icon icon="akar-icons:minus"/>}</Button>
          </div>
        </div>
      }
      <div className={Styles.appliedList}>
      {crowdSourcingTable && 
        <div>
        { props && props.csrappliedResources &&  props.csrappliedResources.length > 0 ?     <section>
            <Table data={props.csrappliedResources} jobId={props.jobId} type={'CRAppliedResources'} total={appliedResources.length} pageChange={props.pageChange} pageSize={props.pageSize} getAppliedCandidates={props.getAppliedCandidates } customerId={props.customerId} jobMetadata={props.jobMetadata} getPositionDetails={props.getPositionDetails} allocatedToId={props.allocatedToId}  submitPostCandidateToJob={props.submitPostCandidateToJob}/>
        </section>  
        : <div className={Styles.noData}>
              <Icon icon="healthicons:i-groups-perspective-crowd-outline" />
              <p><strong>No resources yet!</strong></p>
              <p>No one has been applied for this position.</p>
          </div> }
          </div>
      }
            {/* {props.positionData && props. positionData.crowdsourcing_enabled === true &&  */}
            <div className={Styles.positionhead2}>
          <h3 className="headWithLabel">Provider applied candidates list <div className={Styles.tableCount}>{props.providerResourcesCount}</div></h3>   
          <div className={Styles.actionButton}>
            <Button onClick={() =>{ providerTableShow() }} >{providerTable === false ? <Icon icon="akar-icons:plus" /> : <Icon icon="akar-icons:minus"/>}</Button>
          </div>
        </div>
      {/* } */}
      {providerTable && 
        <div>
        { props && props.providerResources &&  props.providerResources.length > 0 ?     <section>
            <Table data={props.providerResources} jobId={props.jobId} type={'CRAppliedResources'} total={props.providerResources.length} pageChange={props.pageChange} pageSize={props.pageSize} getAppliedCandidates={props.getAppliedCandidates } customerId={props.customerId} jobMetadata={props.jobMetadata} getPositionDetails={props.getPositionDetails} allocatedToId={props.allocatedToId}  submitPostCandidateToJob={props.submitPostCandidateToJob}/>
        </section>  
        : <div className={Styles.noData}>
              <Icon icon="healthicons:i-groups-perspective-crowd-outline" />
              <p><strong>No resources yet!</strong></p>
              <p>No one has been applied for this position.</p>
          </div> }
          </div>
      }
      </div>
      <div className={Styles.positionInfo}>
        <div className={Styles.positionItem}>
          <h5>Positions</h5>
          <label>Total</label>
          <div>{jobMetadata && jobMetadata.resourceCount && jobMetadata.resourceCount}</div>
        </div>
        <div className={Styles.positionItem}>
            <h5>Total closed</h5>
            <div className={Styles.statusWrap}>
              <div className={Styles.won}>
                <label>Win</label>
                <div className={Styles.active}>{jobMetadata && jobMetadata.closedCount && jobMetadata.closedCount}</div>
              </div>
              <div className={Styles.loss}>
                <label>Loss</label>
                <div className={Styles.close}>
                    <FreeField
                    type='number'
                    onBlur={(e: any) => lossCount(e)}  
                    value={lossCountNum ? lossCountNum : ''}
                    onChange={countChange}
                    disabled={props.jobStatus === 3}
                  />
                </div>
              </div>
            </div>
        </div>
        <div className={Styles.positionItem}>
          <h5>Positions</h5>
          <label>Active</label>
          <div className={Styles.active}>{jobMetadata && Math.floor((jobMetadata.resourceCount)-(jobMetadata.closedCount)-(lossCountNum))}</div>
        </div>
      </div>
        <div className={Styles.jobStatusWrap}>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={workType} width="18" />
          </figure>
          <figcaption>Job Type </figcaption>
          <h2>{jobMetadata && jobMetadata.jobType ? jobMetadata.jobType : 'Not Mentioned'}</h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={resourceIcon} />
          </figure>
          <figcaption>Resources Required </figcaption>
          <h2>{jobMetadata && jobMetadata.resourceCount && jobMetadata.resourceCount}</h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={levelIcon} />{" "}
          </figure>
          <figcaption>Experience Level</figcaption>
          <h2>{jobMetadata && jobMetadata.experienceRange  ?  jobMetadata.experienceRange.min +" - "+ jobMetadata.experienceRange.max +' Years' : 'Not Mentioned'}</h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={timeIcon} />
          </figure>
          <figcaption>Contract Duration</figcaption>
          <h2>{jobMetadata && jobMetadata.contractDuration !== '' ? jobMetadata.contractDuration : 'Not Mentioned'} </h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={calendarIcon} />
          </figure>
          <figcaption>Start Date</figcaption>
          { <h2>{jobMetadata && jobMetadata.contractStartDate !== '0' ? 
                  <h2>{jobMetadata.contractStartDate !==0 ? convertMilliSecToDateNew(jobMetadata.contractStartDate) : 'Immediate'}</h2>
                : 'Immediate'}
          </h2>}
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={billingIcon} />
          </figure>
          <figcaption>Billing Rates</figcaption>
            <h2>{jobMetadata && jobMetadata.maximumBudget !== '' ? 
                  <h2>{jobMetadata.minimumBudget !== '' ? jobMetadata.minimumBudget : '0'} ₹ - {jobMetadata.maximumBudget} ₹/ {jobMetadata.billingType}</h2>
                : 'Not Mentioned'}
            </h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={crownIcon} />
          </figure>
          <figcaption>Job Role</figcaption>
          <h2>{jobMetadata && jobMetadata.jobRole && jobMetadata.jobRole.name}</h2>
        </div>
        <div className={Styles.jobStatus}>
          <figure>
            <img src={docIcon} width="18" />
          </figure>
          <figcaption>Document </figcaption>
          <h2>{jobMetadata && jobMetadata.supportingDocument !== "" ? <div onClick={()=>downloadHandle(DownloadresumeName)}>{resumeName}</div>  : 'Not Uploaded'}</h2>
        </div>
        <div className={Styles.jobStatus}> 
          <figure>
            <img src={locationIcon} />
          </figure>
          <figcaption>Location</figcaption>
          <h2>
            { props.jobMetadata.locationPreference && props.jobMetadata.locationPreference.location && props.jobMetadata.locationPreference.location.length > 0 ? 
              props.jobMetadata.locationPreference.location.map((item: any) => {
                return(<Link to="#">{item.name}</Link>)  
              })
              : 'Not Mentioned'
            }
          </h2>  
          </div>
        </div>
      <p>Top 3 skills and expertise most important to the customer</p>
      <div className={Styles.skillsWrap}>
        {jobMetadata && jobMetadata.coreSkills && jobMetadata.coreSkills.map((item : any) =>{
          return(
            <div className={Styles.skillsWrap}>
                <label className={Styles.skills}>{item.skillName}</label>
            </div>
        )})}
      </div>
    { jobMetadata && jobMetadata.otherSkills && jobMetadata.otherSkills.length > 0 && <p>Other skills and expertise</p>}
      <div className={Styles.skillsWrap}>
      {jobMetadata && jobMetadata.otherSkills && jobMetadata.otherSkills.map((item : any) =>{
          return(
            <div className={Styles.skillsWrap}>
                <label className={Styles.skills}>{item.skillName}</label>
            </div>
        )})}
        </div>
        <br></br>
        <h3 className="headWithLabel">
          {jobMetadata && jobMetadata.jobDescription && "Job Description"}
        </h3>
        <p>
        {jobMetadata.jobDescription && <div className="preview"
          dangerouslySetInnerHTML={createMarkup(jobMetadata.jobDescription)}
              // dangerouslySetInnerHTML={jobMetadata.jobDescription && createMarkup(jobMetadata.jobDescription)}
        ></div>}
      {/* {jobMetadata && jobMetadata.jobDescription && <p>{props.convert(jobMetadata.jobDescription).split('\n').map((item :any ,i : any) => <p key = {i}>{item}</p>)} </p> } */}
        </p>
        <br></br>
        <h3 className="headWithLabel">
          {props.positionData && props.positionData.crowdsourcing_enabled === true && "About the company"}
        </h3>
        <p>
        {props.positionData && props.positionData.crowdsourcing_enabled === true && props. positionData.crowdsourcing_company_details !== null &&
          <div className="preview"  dangerouslySetInnerHTML={createMarkup(props.positionData && props. positionData.crowdsourcing_company_details)}>
          </div>
        }
        </p>
        <h3 className="headWithLabel">
        {jobMetadata && jobMetadata.jobResponsibilities && "Job Responsiblities" }
        </h3>
        <p>
      {jobMetadata && jobMetadata.jobResponsibilities && <p>{props.convert(jobMetadata.jobResponsibilities).split('\n').map((item :any ,i : any) => <p key = {i}>{item}</p>)} </p> }
      </p>
    </div>
  </section>
  )
}

export default AppliedCandidates